<template>
  
<FormKitLazyProvider config-file="true">
<FormKit
    type="checkbox"
    name="terms"
    label="Nutzungsbedingungen und Datenschutzerklärungen"
    validation="accepted"
    outer-class="hyphens-auto"
    :sections-schema="{
      label: {
        children: [
          'Ich bestätige hiermit, die ',
          {
            $el: 'a',
            attrs: {
              href: linkAgb,
              class: 'underline',
              target: '_blank',
            },
            children: linkAgbText,
          },
          ' und ',
          {
            $el: 'a',
            attrs: {
              href: linkPrivacy,
              class: 'underline',
              target: '_blank',
            },
            children: 'Datenschutzerklärung',
          },
          ' gelesen und verstanden zu haben.*',
        ],
      },
    }"
  />
</FormKitLazyProvider>

</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const props = defineProps<{
  linkAgbOverride?: {
    uri?: {
      path?: string
    }
    title?: string
  }
}>()

const data = await useInitData()

const linkAgb = computed(() => {
  return props.linkAgbOverride?.uri?.path || data.value.globalConfig.pageAgb
})
const linkPrivacy = computed(() => data.value.globalConfig.pagePrivacy)

const linkAgbText = computed(
  () => props.linkAgbOverride?.title || 'Nutzungsbedingungen',
)
</script>
